import { useParams } from 'react-router-dom'
import PageCalling from 'src/components/common/PageCalling'

import useAPI from 'src/hooks/useAPI'

import { useEffect } from 'react'
import {
  PartnerListData,
  TelTypeState,
  TermsListState,
  uiData,
} from 'src/recoil/common'
import { useRecoilState, useSetRecoilState } from 'recoil'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { PramsKeys } from 'src/types/type'
import styled from 'styled-components'
import useViewButton from 'src/hooks/useViewButton'
import useSubmit from 'src/hooks/useSubmit'
import MvnoModal from 'src/components/views/mkt03/MvnoModal'
import * as S from 'src/styles/styledcomponent/views/mkt03'
import PhoneVerification from 'src/components/views/mkt03/PhoneVerification'
import Terms from 'src/components/views/mkt03/Terms'
import JoinSubmit from 'src/components/views/mkt03/JoinSubmit'
import { Mkt03Header } from 'src/components/views/mkt03/Mkt03Header'
import Footer from 'src/components/views/mkt03/Footer'
import { ToastPopup } from 'src/components/views/mkt03/ToastPopup'
import { useToastPopup } from 'src/hooks/useToastPopup'
import Banner from 'src/components/views/mkt03/Banner'
import { convertTermsData } from 'src/service/join'
import VulnerableCheckModal from 'src/components/views/join/VulnerableCheckModal'

const OutLayout = styled.div`
  background: #ffffff;
`

const Mkt03 = (): JSX.Element => {
  const { pcode, telecom } = useParams<PramsKeys>()
  const api = useAPI('requestTermsList')
  const submit = useSubmit(pcode ?? '')
  const { isShow, openToast } = useToastPopup()

  const { data: getTermsData, isSuccess, isLoading } = api?.useSetQuery({ PCode: pcode })

  const setTermsListState = useSetRecoilState(TermsListState)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const [
    {
      layoutsInsert: { mainBg },
    },
    setUiData,
  ] = useRecoilState(uiData)
  const setTelType = useSetRecoilState(TelTypeState)
  const { RefElement, onMoveToElement, RefInput } = useMoveScroll()
  const { RefVertification } = useViewButton()

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTelType(Number(telecom))
      setTermsListState(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(getTermsData.Body?.Partner.UiData)))
    }
    // eslint-disable-next-line
  }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListState, setTelType, setUiData])

  useEffect(() => {
    openToast()

    window.onbeforeunload = function pushRefresh() {
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Mkt03Header />
      <OutLayout>
        <PageCalling active={isLoading} />
        {isSuccess && (
          <S.Mkt03Wrap mainBg={mainBg}>
            <Banner RefElement={RefElement} />
            <PhoneVerification
              onMoveToElement={onMoveToElement}
              RefInput={RefInput}
              RefElement={RefVertification}
              submit={submit}
              openToast={openToast}
            />
            {!isErrorPartner && <Terms data={getTermsData?.Body?.Terms} />}
            <JoinSubmit submit={submit} />
            <Footer />
          </S.Mkt03Wrap>
        )}
      </OutLayout>

      <ToastPopup isShow={isShow} />
      <MvnoModal submit={submit} />
      <VulnerableCheckModal submit={submit} />
    </>
  )
}
export default Mkt03
